exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".background[data-v-973b1920]{padding:0}.app-container[data-v-973b1920]{background:#fff;padding:0 28px 24px}.description[data-v-973b1920]{color:#606266;font-size:14px;margin:8px 0 20px 0}.section-title[data-v-973b1920]{font-size:16px;font-weight:bold;color:#333}.field-row[data-v-973b1920]{margin-bottom:15px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.field-label[data-v-973b1920]{font-size:14px;line-height:40px}.divider[data-v-973b1920]{border:none;border-top:1px solid #e0e0e0;margin:15px 0}\n", ""]);

// exports
